/**
 * useLogout Hook - Manejo centralizado de cierre de sesión
 *
 * QUÉ HACE:
 * - Encapsula la lógica de logout en un solo lugar
 * - Limpia estado, muestra notificación y redirige
 *
 * QUÉ EXPORTA: useLogout (named)
 *
 * QUÉ NO DEBE HACER:
 * - NO debe contener lógica de UI
 * - NO debe llamar a Firebase directamente
 *
 * REGLAS:
 * - TODO componente que necesite logout DEBE usar este hook
 * - NO duplicar esta lógica en Header, Sidebar, ni ningún otro lugar
 *
 * Uso:
 *   const { handleLogout } = useLogout();
 *   <button onClick={handleLogout}>Cerrar Sesión</button>
 */

import { logger } from "@/lib/logger";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "@/store/authStore";
import { auditoriaService } from "@/features/auditoria/services/auditoria.service";
import toast from "react-hot-toast";

export const useLogout = () => {
  const { logout, user } = useAuthStore();
  const navigate = useNavigate();

  const handleLogout = async () => {
    // Registrar el cierre de sesión antes de limpiar el estado
    if (user) {
      try {
        await auditoriaService.recordLog({
          userId: user.id || "unknown",
          userName: user.nombre || "Usuario",
          action: "logout",
          entidad: "auth",
          resumen: "Cierre de sesión",
          descripcion: `El usuario ${user.nombre} cerró su sesión de forma manual.`,
          severity: "low",
          endpoint: "POST /api/auth/logout",
          details: {
            email: user.email,
            metodoLogin: "Cierre manual",
          },
        });
      } catch (err) {
        logger.error("Error al registrar logout en auditoría:", err);
      }
    }

    logout();
    toast.success("Sesión cerrada correctamente");
    navigate("/login");
  };

  return { handleLogout };
};
